<section class="sh-dialog__content -sh-overflow-scrolling">
  <ng-container *ngTemplateOutlet="(loading$ | async) ? loading : content"></ng-container>
</section>

<ng-template #content>
  <div class="sh-card-table-wrapper">
    <table class="sh-card-table">
      <thead>
        <tr>
          <th scope="col" class="sh-card-table__col">{{ "items.record-errors-dialog.columns.name" | translate }}</th>
          <th scope="col" class="sh-card-table__col">{{ "items.record-errors-dialog.columns.error" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @if (!hasErrors) {
          <td style="width: 2000vw" [attr.colspan]="2">{{ "general.no-results.other" | translate }}</td>
        }

        @if (mailToServices$ | async; as mailTo) {
          @for (recordErrorPair of recordErrorPairs; track recordErrorPair; let i = $index) {
            @for (error of recordErrorPair.errors; track error) {
              <tr>
                <td style="min-width: 400px">{{ recordErrorPair.recordTitle }}</td>
                <td style="min-width: 400px" class="sh-preserve-linebreaks sh-wrap-text">{{ error }}</td>
                @if (actionItems$ | async; as actionItems) {
                  <td class="sh-card-table__col--small">
                    @if (actionItems[i]; as group) {
                      <sh-action-group [actionGroup]="group"></sh-action-group>
                    }
                  </td>
                }
              </tr>
            }
          }
        }
      </tbody>
    </table>
  </div>
</ng-template>

<ng-template #loading>
  <sh-notification [message]="'ui.loading' | translate"></sh-notification>
</ng-template>
